<!--
 * @Description: 潜在客户新增
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-05-31 17:58:57
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" returnName="DcCosLbuPotential" isEdit :data="data" :permissionPage="permissionBasic" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
const permissionBasic = {
  save: 'lbu_potential_add_btn'
}
const data = ref()
</script>
<script lang="ts">
export default { name: 'DcCosLbuPotentialAdd' }
</script>
<style lang="scss" scoped></style>
